import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Instagram = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 40.578H10a10 10 0 0 1-10-10v-20a10 10 0 0 1 10-10h20a10 10 0 0 1 10 10v20a10 10 0 0 1-10 10Z"
        fill="#FF3A55"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 11.828H30A5.625 5.625 0 0 0 30.575.607c-.191-.01-.38-.029-.575-.029H10a10 10 0 0 0-10 10v20a18.75 18.75 0 0 1 18.75-18.75Z"
        fill="#FF796C"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 20.578a10 10 0 1 0 10 10v-20a10 10 0 0 1-10 10Z"
        fill="#E00047"
      />
      <Path
        d="M27.813 14.328a1.562 1.562 0 1 0 0-3.125 1.562 1.562 0 0 0 0 3.125Z"
        fill="#fff"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 15.578a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0-2.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Z"
        fill="#fff"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5 14.328a6.25 6.25 0 0 0-6.25-6.25h-12.5a6.25 6.25 0 0 0-6.25 6.25v12.5a6.25 6.25 0 0 0 6.25 6.25h12.5a6.25 6.25 0 0 0 6.25-6.25v-12.5Zm2.5 0a8.75 8.75 0 0 0-8.75-8.75h-12.5A8.75 8.75 0 0 0 5 14.328v12.5a8.75 8.75 0 0 0 8.75 8.75h12.5a8.75 8.75 0 0 0 8.75-8.75v-12.5Z"
        fill="#fff"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(0 .578)" d="M0 0h40v40H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Instagram
